import { ThemeOptions } from '@mui/material';

export interface CustomTheme extends ThemeOptions {
  name?: string;
}

const components : any = {
  MuiDivider: {
    styleOverrides: {
      root: {
        fontSize: '14px'
      }
    }
  },

  MuiTableRow: {
    styleOverrides: {
      head: {
        textTransform: 'uppercase',
        backgroundColor: '#1976d2'
      },
      root: {
        lineHeight: '20px'
      },

    }
  },
  MuiTableCell: {
    styleOverrides: {
      head: {

        color: '#ffffff',
      },
      root: {
        padding: '5px',
        paddingLeft: '10px'
      },
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        fontSize: '15px',
        borderTopRightRadius: '10px',
        borderTopLeftRadius: '10px',
        border: '1px solid rgb(224, 224, 224)'
      }
    }
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        borderRadius: '10px',
        border: '1px solid rgb(224, 224, 224)',
        marginTop: '10px'
      }
    }
  },
};

const theme: CustomTheme = {
  name: 'Contesto 1',
  palette: {
    primary: {
      main: '#ae0427'
    },
    secondary: {
      main: '#9c27b0'
    },
    success: {
      main: '#2e7d32'
    },
    warning: {
      main: '#ED6C02'
    },
    error: {
      main: '#d32f2f'
    },
    info: {
      main: '#c8c8c8'
    }
  },
  typography: {
    button: {
      textTransform: 'none'
    },
    h6: {
      fontSize: '14px'
    },
    h5: {
      fontSize: '16px'
    },
    h4: {
      fontSize: '20px'
    },
    h3: {
      fontSize: '24px'
    },
    h2: {
      fontSize: '30px'
    },
    h1: {
      fontSize: '40px'
    }
  },
  components: components 
};
const defaultTheme: CustomTheme = {
  name: 'Contesto 2',
  palette: {
    primary: {
      main: '#1976d2'
    },
    secondary: {
      main: '#9c27b0'
    },
    success: {
      main: '#2e7d32'
    },
    warning: {
      main: '#ED6C02'
    },
    error: {
      main: '#d32f2f'
    },
    info: {
      main: '#c8c8c8'
    }
  },
  typography: {
    button: {
      textTransform: 'none'
    },
    h6: {
      fontSize: '14px'
    },
    h5: {
      fontSize: '16px'
    },
    h4: {
      fontSize: '20px'
    },
    h3: {
      fontSize: '24px'
    },
    h2: {
      fontSize: '30px'
    },
    h1: {
      fontSize: '40px'
    }
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          fontSize: '14px'
        }
      }
    }
  }
};



const sistematicaTheme: CustomTheme = {
  name: 'Tema Veronica',
  palette: {
    primary: {
      main: '#1976d2'
    },
    secondary: {
      main: '#9c27b0'
    },
    success: {
      main: '#2e7d32'
    },
    warning: {
      main: '#ED6C02'
    },
    error: {
      main: '#d32f2f'
    },
    info: {
      main: '#c8c8c8'
    }
  },
  typography: {

    button: {
      textTransform: 'none'
    },
    h6: {
      fontSize: '14px'
    },
    h5: {
      fontSize: '16px'
    },
    h4: {
      fontSize: '20px'
    },
    h3: {
      fontSize: '24px'
    },
    h2: {
      fontSize: '30px'
    },
    h1: {
      fontSize: '40px'
    }
  },
  components: components 
};
type ContextInterface = {
  [key: string]: CustomTheme;
};

const context: ContextInterface = {
  dark: theme,
  light: theme,
  //default: defaultTheme, 
  default: sistematicaTheme
};

export default context;
